import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import jquery from "jquery";
import Bootstrap from "bootstrap";
import * as VeeValidate from "vee-validate";
import { BootstrapVue } from "bootstrap-vue";
import ElementUI from 'element-ui';
import { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/styles/style.scss";
import locale from 'element-ui/lib/locale/lang/en'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import data from './assets/json/data';
import VueCarousel from 'vue-carousel';
export const eventBus = new Vue(); // added line

import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";
// import firebase from "firebase";
import firebase from "firebase/app";
import "firebase/messaging";

var infiniteScroll = require('vue-infinite-scroll');
Vue.use(infiniteScroll)
Vue.use(VueCarousel);


Vue.use(BootstrapVue);
window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(VeeValidate, {
    // This is the default
    inject: true,
    // Important to name this something other than 'fields'
    fieldsBagName: "veeFields",
});

var firebaseConfig = {
    apiKey: "AIzaSyC5Y7aiZm6fWDobwJVtjE-w8_hHzi0D1Hc",
    authDomain: "payscript-89144.firebaseapp.com",
    projectId: "payscript-89144",
    storageBucket: "payscript-89144.appspot.com",
    messagingSenderId: "426589871038",
    appId: "1:426589871038:web:341ed7aa80508714af77ef",
    measurementId: "G-7H21122Q0C"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();
Object.defineProperty(Vue.prototype, '$messaging', {
    value: messaging
});

var Lang = require("vuejs-localization");
Lang.requireAll(require.context("./lang", true, /\.js$/));
Vue.use(Lang);
Vue.use(ElementUI, { locale });
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

new Vue({
    el: '#app',
    router,
    store,
    jquery,
    Bootstrap,
    // extend,
    render: h => h(App),
    created() {
        let self = this;
        Notification.requestPermission()
            .then(function () {
                return messaging.getToken()
            })
            .then(function (token) {
                console.log(token);
                self.$store.commit('setFcmToken', token)
                if (self.$store.getters.login.token != null) {
                    let deviceFormData = {
                        deviceId: self.$store.getters.deviceId,
                        deviceToken: self.$store.getters.fcmToken,
                        deviceType: 3
                    };
                    self.$store.dispatch('updateDeviceInformation', deviceFormData).then(value => { });
                }
            }).catch(function (err) {
                console.log('Token Error' + err);
            });

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', (event) => {
                const messageData = event.data;
                if (messageData.type === 'background-message-received') {
                    console.log('Received background message:', messageData.payload);

                    if (this.$store.getters.login.token) {
                        const chatData = {
                            formReferenceId: messageData.payload.formReferenceId,
                            formsManagementId: messageData.payload.formsManagementId
                        };
                        chatData.loading = false;
                        const retrievedData = localStorage.getItem('pDetails');
                        const parsedData = JSON.parse(retrievedData);
                        if (parsedData.formid == messageData.payload.formId) {
                            self.$store.dispatch("chatConversation", chatData).then((response) => {
                                if (response.status == 200) {
                                    console.log("Getting Response Data: ", response.data)
                                    self.$store.commit("setReceivedMessage", response.data);
                                    let data = {
                                        pageNo: "1",
                                        search: "",
                                    };
                                    data.loading = true;
                                    if (self.$store.state.groupRequestDetails.length == 0) {
                                        self.$store
                                            .dispatch("chatConversationList", data)
                                            .then((response) => {
                                                if (response.status == 200) {
                                                    self.$store.commit("setReceived", response.data);
                                                }
                                            });
                                    }
                                }
                            })
                        } else {
                            let data = {
                                pageNo: "1",
                                search: "",
                            };
                            data.loading = true;
                            self.$store
                                .dispatch("chatConversationList", data)
                                .then((response) => {
                                    if (response.status == 200) {
                                        self.$store.commit("setReceived", response.data);
                                    }
                                });
                        }
                    }
                }
            });
        }

        messaging.onMessage(function (payload) {
            console.log('here', payload);
            if ((self.$store.getters.chatIdPayload.formReferenceId == "" && self.$store.getters.chatIdPayload.formsManagementId == "") || (self.$store.getters.chatIdPayload.formReferenceId != payload.data.formReferenceId && self.$store.getters.chatIdPayload.formsManagementId != payload.data.formsManagementId)) {
                if (self.$store.getters.chatIdPayload.formReferenceId == "" && self.$store.getters.chatIdPayload.formsManagementId == "") {
                    self.$store.commit("setChatIdPayload", { formReferenceId: payload.data.formReferenceId, formsManagementId: payload.data.formsManagementId });

                }
                if (payload.data.notificationType == 'ChatConversation') {
                    let data1 = {
                        formReferenceId: payload.data.formReferenceId,
                        formsManagementId: payload.data.formsManagementId,
                        pageNo: "1",
                    };
                    data1.loading = false;
                    const retrievedData = localStorage.getItem('pDetails');
                    const parsedData = JSON.parse(retrievedData);
                    if (parsedData.formid == payload.data.formId) {
                        self.$store.dispatch("chatConversation", data1).then((response) => {
                            if (response.status == 200) {
                                console.log("Getting Response Data: ", response.data)
                                self.$store.commit("setReceivedMessage", response.data);
                                let data = {
                                    pageNo: "1",
                                    search: "",
                                };
                                data.loading = true;
                                if (self.$store.state.groupRequestDetails.length == 0) {
                                    self.$store
                                        .dispatch("chatConversationList", data)
                                        .then((response) => {
                                            if (response.status == 200) {
                                                self.$store.commit("setReceived", response.data);
                                            }
                                        });
                                }
                            }
                        })
                    } else {
                        let data = {
                            pageNo: "1",
                            search: "",
                        };
                        data.loading = false;
                        self.$store
                            .dispatch("chatConversationList", data)
                            .then((response) => {
                                if (response.status == 200) {
                                    self.$store.commit("setReceived", response.data);
                                }
                            });
                    }
                }

            }


            let isGroupRequest = payload.data.notificationType == 'Groups';
            if (isGroupRequest) {
                data.homeLink[4].count = payload.data.badge;
            } else {
                data.homeLink[2].count = payload.data.badge;
            }
            if (self.$store.getters.login.token != null) {
                const noteTitle = payload.notification.title;
                const noteOptions = {
                    body: payload.notification.body,
                    icon: payload.notification.icon,
                };
                let not = new Notification(noteTitle, noteOptions);

                not.onclick = function (event) {
                    if (isGroupRequest) {
                        self.$swal.fire({
                            title: '',
                            text: payload.notification.body,
                            type: '',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'ACCEPT',
                            cancelButtonText: 'CANCEL',
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.value) {
                                let formData = {
                                    formsManagementId: payload.data.formsManagementId
                                };
                                self.$store.dispatch('assignToDoctor', formData).then(value => {
                                    if (value.status == 200) {
                                        let data = {};
                                        self.$store.dispatch('getGroupRequestList', data)
                                            .then(response => {
                                                let filteredObject = response.filter(c => { return c.formsManagementId == payload.data.formsManagementId })
                                                self.$store.commit('setGroupRequestDetails', filteredObject[0]);
                                                let obj = { message: 'Request assigned successfully' };
                                                self.$store.commit('setShowAlert', obj);
                                                if (self.$route.name != 'group-request-details') {
                                                    self.$router.push({ name: 'group-request-details' });
                                                }
                                            })
                                    } else {
                                        self.$swal.fire({
                                            title: 'Request already accepted',
                                            text: 'This request has been accepted by another doctor',
                                            type: 'error',
                                            showCancelButton: true,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'OK'
                                        }).then((result) => { });
                                    }
                                });
                            }
                        });
                    } else {
                        if (self.$route.name != 'script-requests') {
                            self.$router.push({ name: 'script-requests' });
                        }
                    }
                    not.close();
                };
            }
        });
    }
}).$mount('#app')
